import * as Yup from "yup";

export const GenerateMeterDeliveryMaterialsSchema = Yup.object().shape({
  materials: Yup.array().of(Yup.object().shape({
    material: Yup.string().required("Required"),
    quantity: Yup.number().min(1, "Cannot be less than 1").required("Required"),
  })),
  notes: Yup.string(),
});

export const GenerateMeterDeliveryMaterialsInitialValues = {
  materials: [] as {
    material: any,
    quantity: number,
  }[],
  notes: "",
};
